import { createTheme } from '@mui/material/styles';
import theme from 'apollo-react/theme';

export const SELECTED_TABLE_ROW_STYLES = {
  backgroundColor: '#0768fd !important',
  color: '#fff !important',
  '& > td *': {
    color: '#fff !important',
    fill: 'currentColor',
  },
  '& > td textarea': {
    color: '#666 !important',
  },
  '& > td textarea + div *': {
    color: '#595959 !important',
  },
  '& [class*="MuiCheckbox-root"] svg path:nth-of-type(2)': {
    fill: '#0768fd !important',
  },
};

const customTheme = () => {
  theme.components.MuiTableRow.styleOverrides = {
    root: {
      '&$selected': SELECTED_TABLE_ROW_STYLES,
    },
  };

  theme.components.MuiTableSortLabel.styleOverrides = {
    root: {
      '&.Mui-active': {
        '& svg': {
          color: '#0768fd !important',
        },
      },
    },
  };

  theme.components.MuiPaper.styleOverrides = {
    elevation1: {
      border: 'none',
    },
  };

  return theme;
};

export default createTheme({ ...customTheme() });
